import {
  ApiResponseType,
  API_ROUTES,
  API_ROUTE_PREFIX,
  IAddPassportRequestParams,
  IPassportDetailsResponseData,
} from "@tm/api-utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { AxiosResponse } from "axios";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getPassportDetails = async (
  reqData: IAddPassportRequestParams
): Promise<AxiosResponse<ApiResponseType<IPassportDetailsResponseData>>> => {
  try {
    const {
      bookingId,
      pageId,
      partner = PARTNER.MMT,
      headers,
      cmp,
      query,
      dvid,
    } = reqData;
    const params = { bookingId, pageId, ...query };
    const urlParams = setURLQueryParams(params);

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_PASSPORT_DETAILS}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp, dvid },
      }
    );
    return response;
  } catch (error) {
    console.log("Error", { error });
    throw error;
  }
};
